import { Outlet, isRouteErrorResponse, useRouteError } from "react-router-dom";
import { Alert, AlertTitle, Box, Stack, Typography } from "@mui/material";
import Layout from "../../layout/layout";
import AppLayout from "../../layout/AppLayout";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DashboardLayout from "../../layout/DashboardLayout";
import {FC} from "react";

// base Component to display Error


const sanitizeError= (error: Error | string | any) => {

       let errorMessage:string = "";
    if (isRouteErrorResponse(error)) {
        // error is type `ErrorResponse`
        errorMessage = String(error.status) || error.statusText;
    } else if (error instanceof Error) {
        console.log(error.stack, "sdds")
        errorMessage = error.message;
    } else if (typeof error === 'string') {
        errorMessage = error;
    } else {
        console.error(error);
        errorMessage = 'Unknown error';
    }
    return errorMessage
}


export const ErrorMessageLayout: FC<{ error: any | unknown, errorTitle?: string }> = ({error, errorTitle}) => {

    const errorMessage= sanitizeError(error)

    return (

        <Box sx={{ flex: 1, overflow: "auto" }}>
            <Stack alignItems={"center"}>
                <Typography variant="h6"> {errorTitle ? errorTitle :"X2BIM is currently down!! "} </Typography>
                <Accordion sx={{ width: "60%" }}>
                    <AccordionSummary
                        expandIcon={<ArrowDownwardIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Typography>Show Errors </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            {errorMessage}
                        </Typography>
                        <Typography>{error.stack ? error.stack : ""} </Typography>
                    </AccordionDetails>
                </Accordion>

                <Box component={"img"} sx={{ width: "35%" }} src="/public/images/drone-fail.png"></Box>

            </Stack>
        </Box>

    );
}

export const ErrorAlert: FC<{error: any, errorTitle: string}> = ({error, errorTitle}) => {
    const errorMessage= sanitizeError(error)
    return <Alert severity="error">
    <AlertTitle>{errorTitle ? errorTitle :"Something Went wrong!! "}</AlertTitle>
    {errorMessage}
  </Alert>
}

export const GeneralErrorWrapper= () => {
    const error = useRouteError()
    return <ErrorMessageLayout error={error}/>
}


export const AppErrorWrapper= () => {
    const error = useRouteError()
    return <ErrorMessageLayout error={error}/>
}


export const DashboardErrorWrapper: FC<{errorOrigin: string}> = ({errorOrigin}) => {
    const error= useRouteError()
    const errorTitle = errorOrigin ? `Something went wrong in ${errorOrigin}!!!` : ""
    return <ErrorMessageLayout error={error} errorTitle={errorTitle}/>
}


export const ComponentErrorWrapper: FC<{errorOrigin: string}> = ({errorOrigin}) => {
    const error= useRouteError()
    const errorTitle = errorOrigin ? `Something went wrong in ${errorOrigin}!!!` : ""
    return <ErrorAlert error={error} errorTitle={errorTitle}/>
}
